// extracted by mini-css-extract-plugin
export default {"productGallery":"aJ-z","inQuickShop":"bJ-z"};